import { render, staticRenderFns } from "./PendingReview.vue?vue&type=template&id=590e2486&scoped=true"
import script from "./PendingReview.vue?vue&type=script&lang=js"
export * from "./PendingReview.vue?vue&type=script&lang=js"
import style0 from "./PendingReview.vue?vue&type=style&index=0&id=590e2486&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e2486",
  null
  
)

export default component.exports